<template>
<div class="pageWidth mt30 tabs member" id="member">
    <div class="bdtit z">
        <ul class="tabsTag nobgTab nomarlTag">
            <li class="first" @mouseenter="move(1)" :class="{'curr':dis1}"><a target="_blank">中国文物艺术品拍卖企业自律公约成员</a></li>
            <li @mouseenter="move(2)" :class="{'curr':dis2}"><a target="_blank">中国文物艺术品拍卖标准化达标企业</a></li>
        </ul>
    </div>
    <div class="tabsCon" :style="{display:dis1?'block':'none'}">
        <template v-if="zhongpaiList">
            <dl v-for="(item,i) in zhongpaiList" :key="i">
                <dt>{{item.name}}<span>（{{item.organ_count}}）</span></dt>
                <dd :style="item.isOpen?'height: auto !important;':''">
                    <div class="fold" v-if="item.organ_list.length > 16">
                        <div class="open" @click="openMore(item)"><span class="text">{{item.isOpen?'收起':'展开'}}</span><b></b></div>
                    </div>
                    <div class="areaWrap">
                        <ul class="areaList">
                            <li class="">
                                <span v-for="(m,k) in item.organ_list" :key="k">
                                    <template v-if="m.name=='中国嘉德'">
                                        <a :href='`https://www.cguardian.com`' target="_blank">{{m.name}}</a>
                                    </template>
                                    <template v-else-if="m.organ_zone">
                                        <a :href="'/'+m.organ_zone" target="_blank">{{m.name}}</a>
                                    </template>
                                    <template v-else>
                                        <a :href="'/org_detail/'+m.organ_code" target="_blank">{{m.name}}</a>
                                    </template>
                                    <img width="14" height="14" alt="已开通官网" title="已开通官网" src="../../../assets/imgs/old/approve.png" v-if="m.organ_zone"></span>
                            </li>
                        </ul>
                    </div>
                </dd>
            </dl>
        </template>
    </div>
    <div class="tabsCon" :style="{display:dis2?'block':'none'}">
        <template v-if="standList">
            <dl v-for="(item,i) in standList" :key="i">
                <dt>{{item.name}}<span>（{{item.organ_count}}）</span></dt>
                <dd :style="item.isOpen?'height: auto !important;':''">
                    <div class="fold" v-if="item.organ_list.length > 16">
                        <div class="open" @click="openMore(item)"><span class="text">{{item.isOpen?'收起':'展开'}}</span><b></b></div>
                    </div>
                    <div class="areaWrap">
                        <ul class="areaList">
                            <li class="">
                                <span v-for="(m,k) in item.organ_list" :key="k">
                                    <template v-if="m.name=='中国嘉德'">
                                        <a :href='`https://www.cguardian.com`' target="_blank">{{m.name}}</a>
                                    </template>
                                    <template v-else-if="m.organ_zone">
                                        <a :href="'company/'+m.organ_zone" target="_blank">{{m.name}}</a>
                                    </template>
                                    <template v-else>
                                        <a :href="m.link" target="_blank">{{m.name}}</a>
                                    </template>
                                    <img width="14" height="14" alt="已开通官网" title="已开通官网" src="../../../assets/imgs/old/approve.png" v-if="m.organ_zone"></span>
                            </li>
                        </ul>
                    </div>
                </dd>
            </dl>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: "member",
    props: {
        zhongpaiList: {
            type: Array
        },
        standList: {
            type: Array
        }
    },
    data() {
        return {
            dis1: true,
            dis2: false
        }
    },
    mounted() {
    },
    methods: {
        group(arr, length) {
            let index = 0;
            let newArray = [];
            while (index < arr.length) {
                newArray.push(arr.slice(index, index += length));
            }
            return newArray;
        },
        move(num) {
            switch (num) {
                case 1:
                    this.dis1 = true
                    this.dis2 = false
                    break
                case 2:
                    this.dis1 = false
                    this.dis2 = true
            }
        },
        openMore(e) {
            e.isOpen=!e.isOpen;
            // let objArr = e.path,
            //     obj, target = e.target;
            // let that = this
            // let oBox = that.findParentByClass(target, 'fold')
            // objArr.forEach(function (item) {
            //     if (item.nodeName == 'DD') {
            //         obj = item
            //         if (target.classList.contains('open') || that.findParentByClass(target, 'open')) {
            //             oBox.querySelector('.open').classList.add('close')
            //             oBox.querySelector('.open').classList.remove('open')
            //             oBox.querySelector('.text').innerHTML = '收起'
            //             obj.style.height = 'auto'
            //             return false
            //         }
            //         if (target.classList.contains('close') || that.findParentByClass(target, 'close')) {
            //             oBox.querySelector('.close').classList.add('open')
            //             oBox.querySelector('.close').classList.remove('close')
            //             oBox.querySelector('.text').innerHTML = '展开'
            //             obj.style.height = '64px'
            //             return false
            //         }
            //     }
            // })
        },
        findParentByClass(obj, className) {
            while (obj) {
                if (obj.classList && obj.classList.contains(className)) {
                    break;
                } else {
                    obj = obj.parentNode;
                }
            }
            return obj;
        },
    }
}
</script>

<style scoped>
.nobgTab {
    /* border-top: 3px solid #000000; */
    padding: 10px 0px 13px;
    font-family: "Microsoft YaHei";
}

.nobgTab li {
    border-right: 1px solid #CCCCCC;
    padding: 0 19px 0 20px;
    line-height: 1;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}

.tabsTag li {
    float: left;
    display: inline;
    zoom: 1;
}

.member .nobgTab .first {
    border-left: none;
    padding-left: 0px;
}

.member .nobgTab li {
    border-left: 1px solid #ccc;
    border-right: 0px;
    cursor: pointer;
}

.member dl {
    padding: 15px 0px;
    background: url(../../../assets/imgs/old/dashed_gray.png) 0px 100% repeat-x;
}

.member dt {
    float: left;
    _display: inline;
    font: 18px/22px 'Microsoft Yahei';
    width: 92px;
    height: 54px;
    padding-left: 10px;
    padding-top: 10px;
    color: #666666;
    background: url(../../../assets/imgs/old/bg.png) 0px 0px repeat;
}

.member dt span {
    font-family: Verdana;
    display: block;
    color: #999999;
    font-size: 12px;
}

.member dd {
    margin-left: 102px;
    overflow: hidden;
    font-size: 12px;
    height: 64px;
    transition: .2s height ease-in-out;
}

.member .fold {
    float: right;
    width: 64px;
    height: 64px;
    background: url(../../../assets/imgs/old/bg.png) 0px 0px repeat;
}

.member .open,
.member .close {
    display: block;
    width: 64px;
    height: 64px;
    padding-top: 11px;
    padding-left: 20px;
    cursor: pointer;
}

.member .open b,
.member .close b {
    display: block;
    background-image: url(../../../assets/imgs/old/fold.png);
    background-repeat: no-repeat;
    width: 7px;
    height: 5px;
    cursor: pointer;
    margin-left: 8px;
    overflow: hidden;
}

.member .close b {
    background-position: -17px 0px
}

.member .areaWrap {
    margin-right: 79px;
    overflow: hidden;
}

.member .areaWrap.show {
    height: auto;
}

.member .areaWrap li {
    overflow: hidden;
    _zoom: 1;
}

.member .areaWrap span {
    float: left;
    padding-left: 20px;
    width: 98px;
    line-height: 32px;
    zoom: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
}

.member .areaWrap span img {
    margin: 0 0 0 4px;
}

.member .areaWrap .odd {
    background: #f9f9f9;
}

.member .fold:hover .open {
    background: #0F820C;
    color: #FEFEFE;
}

.member .fold:hover .open b {
    background-position: 0px -10px;
}

.nobgTab a:hover,
.nobgTab .curr a {
    color: #fefefe;
    background-color: #0f820c;
}
</style>
